module.exports = __webpack_public_path__ + "static/media/img11mob.336f8689.jpg";